import { storeImages } from "@/mocks/techData";

const reasons = [
  {
    n: "01",
    title: "Real Technology Range",
    text: "Mobiles, laptops and the everyday accessories that keep them useful.",
  },
  {
    n: "02",
    title: "Genuine Accessories",
    text: "Chargers, cases, cables, headsets and speakers — quality essentials.",
  },
  {
    n: "03",
    title: "Local to Liverpool",
    text: "A neighbourhood technology retailer based on Eastdale Road.",
  },
  {
    n: "04",
    title: "Out at the Market",
    text: "The same range and service, brought directly to the market stall.",
  },
];

export default function WhyFist() {
  return (
    <section id="why" className="bg-foreground-100 py-20 md:py-28">
      <div className="container-x grid items-center gap-10 lg:grid-cols-[1fr_1.1fr]">
        <div>
          <p className="eyebrow mb-4 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-foreground-950"></span>
            The Difference
          </p>
          <h2 className="section-title">Why Fist Limited?</h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600">
            No fluff — just straightforward technology retail in Liverpool, with the essentials you
            actually use every day.
          </p>

          <div className="mt-8 border-t border-foreground-200">
            {reasons.map((r) => (
              <div key={r.n} className="flex items-start gap-5 border-b border-foreground-200 py-5">
                <span className="font-heading text-sm text-primary-600">{r.n}</span>
                <div>
                  <h3 className="font-heading text-base text-foreground-950">{r.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600">{r.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-xl">
            <div className="aspect-[4/3] md:aspect-[4/5]">
              <img
                src={storeImages.interior}
                alt="Interior of the Fist Limited technology shop in Liverpool"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
          <div className="absolute -bottom-4 left-4 rounded-lg bg-primary-500 px-4 py-3 md:-bottom-6 md:left-6 md:px-5 md:py-4">
            <p className="font-heading text-lg text-foreground-950 md:text-xl">86 Eastdale Road</p>
            <p className="text-xs text-foreground-950/80">Liverpool · L15 4HW</p>
          </div>
        </div>
      </div>
    </section>
  );
}